import React from 'react'; 
import {  ResponsiveContainer, Cell, PieChart, Pie } from "recharts";
import { isNaN} from 'lodash'
import { injectIntl } from 'react-intl';

function ProgressCircle(props) { 

    const [data, setData] = React.useState([])
    
    React.useEffect(() => {

      setData(createData(parseInt((props.value/props.totalVarde)*100) > 100 ? 100 : parseInt((props.value/props.totalVarde)*100)))

    }, [props.value,props.totalVarde])

    const createData = (_progress) => {
      if(isNaN(_progress)) _progress = 0
      return [
        { name: props.intl.formatMessage({ id: 'Budget.Label' }), value: (100-_progress),},
        { name: props.intl.formatMessage({ id: 'Label.Currect' }), value: _progress,},
      ]
    }

    const COLORS = [
      { start: "#E6E6E6", end: "#E6E6E6" },
      { start: "rgba(12,150,156,1)", end: "rgba(125,106,154,1)" },
    ];
    const data2 = [
      {name:'awd', value: 100}
    ]

    return ( 
    <> 
      <ResponsiveContainer width={120} height="100%">
          <PieChart > 
          <defs>
            {data.map((entry, index) => (
              <linearGradient id={`myGradient${index}`}>
                <stop
                  offset="0%"
                  stopColor={COLORS[index % COLORS.length].start}
                />
                <stop
                  offset="100%"
                  stopColor={COLORS[index % COLORS.length].end}
                />
              </linearGradient>
            ))}
          </defs>
            <Pie  startAngle={-270} data={data2} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={'63.5%'} outerRadius={'90%'} stroke="none"  fill={'#E6E6E6'}>
              <Cell key={0} fill={`#E6E6E6`}/>
            </Pie>
            <Pie  startAngle={-270} data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={'63.5%'} outerRadius={'90%'} stroke="none" cornerRadius={40} fill={'#E6E6E6'} >
              {
                  data.map((d,i) => <Cell key={i} fill={`url(#myGradient${i})`}/>)
              }
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </>
  ); 

} 

export default injectIntl(ProgressCircle);